import { css } from 'styled-components';
import { fonts } from './variables';

export default css`
  html,
  body {
    height: 100%;
    width: 100%;
    -webkit-overflow-scrolling: touch;
  }

  html {
    overflow-x: hidden;
  }

  body {
    font-family: ${fonts.monterrat};
    max-width: 100vw;
    min-width: 398px;

    #root {
      height: 100%;
      width: 100%;
    }
  }

  a {
    color: inherit;
    text-decoration: none;

    &:hover,
    &:focus {
      text-decoration: underline;
    }
  }

  img {
    max-width: 100%;
    position: relative;
    vertical-align: middle;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/globals.js